import { compose, map, toPairs } from 'ramda';
import { sharePointHelpers } from "@qdabra/forms-shared/sharePoint";
import { CRLF } from '../../constants/newlines'
import buildMultipartRequest from '../buildMultipart';
import { getBoundary, parseMultipart } from '../parseMultipart';
import { parseHttpResponse } from '../parseHttp';

const { findRestError, JSON_ACCEPT_MIMETYPE } = sharePointHelpers;

const MULTIPART_BOUNDARY = 'batch_6954f4b3-86f4-4aef-b175-72878c00ca51';
const CONTENT_TYPE_HTTP = 'application/http';

const makeHeaderLines = compose(
    map(([key, value]) => `${key}: ${value}`),
    toPairs,
);

const requestToBatchEntry = ({ method = 'GET', url, headers = {} }) => {
    const mainLine = `${method} ${url} HTTP/1.1`;
    const headerLines = makeHeaderLines({
        Accept: JSON_ACCEPT_MIMETYPE,
        ...headers,
    });

    const value = [
        mainLine,
        ...headerLines,
    ].join(CRLF);

    return {
        contentType: CONTENT_TYPE_HTTP,
        value,
    };
};

// [{ method: String, url: String, headers?: { String: String }}] -> { contentType: String, value: String }
export const buildRestBatch = compose(
    (parts) => buildMultipartRequest(parts, MULTIPART_BOUNDARY),
    map(requestToBatchEntry),
);

const processPart = (part) => {
    const { body } = parseHttpResponse(part);

    try {
        const parsed = JSON.parse(body);

        const error = findRestError(parsed);

        if (error) {
            return { error };
        }

        return parsed;
    } catch (e) {
        return {
            error: `Failed to parse JSON from response: ` + e.message,
        };
    }
};

export const parseRestBatchResult = ({ resultBody, contentType }) => {
    const boundary = getBoundary(contentType);

    if (!boundary) {
        throw new Error('Could not determine multipart boundary from content type ' + contentType);
    }

    return parseMultipart(resultBody, boundary).map(processPart);
};


export const performBatchQuery = (
    shpAccess,
    siteUrl,
    { contentType, body: content },
    { listId, listName } = {},
) => shpAccess.makeRestApiRequestAsync(
    siteUrl,
    '$batch',
    'POST',
    {
        contentType,
        content,
        listId,
        listName,
        resultHandler: (_, result) => result,
    },
);